module.exports = __webpack_public_path__ + "static/quiz_girl-934e50e80c154b4f5c3b3797a1cbbce5.svg";